import React, { useState } from 'react'
import { Query } from 'react-apollo'
import ReactTable from 'react-table'
import _ from 'lodash'
import {
  Div, H3, Loading, DynamicButtonLink,
} from 'konsys-ui'
import config from './config'
import { status } from '../constants'
import { theme } from '../../../styles/_variables'
import './style-css.css'
import { Wrapper } from '../../../components/trailer-components'
import { GET_TRAILER_LIST } from '../../../constants/graphql/query'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

export const colorSelector = (e) => {
  switch (e) {
    case status.AVAILABLE:
      return color.success
    case status.REPAIRING:
      return color.warning
    case status.OUT_OF_SERVICE:
      return color.error
    default:
      return color.charcoalGrey
  }
}

const Index = () => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
        <H3 bold color={color.primaryColor} margin='32px 0'>หางพ่วงทั้งหมด</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <DynamicButtonLink link='/trailer/add' condition={_.includes(window.perms, PERMISSION.CREATE_TRUCK)} props={{ text: 'เพิ่มหางพ่วง' }} />
        </Div>
      </Div>
      <TrailerList />
    </Div>
  )
}

export const TrailerList = () => {
  const [current, setCurrent] = useState(0)
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [filtered, setFiltered] = useState([])
  return (
    <Wrapper overflow padding='0 0 40px 0' flex>
      <Query
        query={GET_TRAILER_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >
        {
          ({
            error, loading, data, refetch,
          }) => {
            if (error) return <p>เกิดข้อผิดพลาด</p>
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            const trailerlist = data.TrailerList.lists
            return (
              <Div margin='auto'>
                <ReactTable
                  className='table'
                  data={trailerlist} // *
                  resizable={false}
                  columns={config.columns} // *
                  minRows={5}
                  manual
                  showPageSizeOptions={false}
                  getTdProps={() => ({ disabled: false, refetch })} // *
                  getTrProps={(state, rowInfo) => { // *
                    if (rowInfo) {
                      return {
                        style: {
                          padding: '8px 0',
                          backgroundColor: '#ffffff',
                          borderLeft: `3px solid ${colorSelector(rowInfo.original.status)}`,
                        },
                      }
                    } return {}
                  }}
                  previousText='ก่อนหน้า'
                  nextText='ถัดไป'
                  pageText='หน้า'
                  ofText='จาก'
                  noDataText='ไม่พบข้อมูล'
                  page={current}
                  pages={Math.ceil(data.TrailerList.totalFilter / 5)}
                  onPageChange={page => setCurrent(page)}
                  onFilteredChange={async (newFiltered) => {
                    const newOjb = {}
                    await newFiltered.forEach((v) => {
                      switch (v.id) {
                        case 'truck.plateNumber':
                          Object.assign(newOjb, {
                            plateNumber: v.value,
                          })
                          break
                        case 'type.nameTh':
                          Object.assign(newOjb, {
                            nameTh: v.value,
                          })
                          break
                        default:
                          Object.assign(newOjb, {
                            [v.id]: v.value,
                          })
                          break
                      }
                    })
                    setFiltered(newOjb)
                    setCurrent(0)
                  }}
                  onSortedChange={async (newSorted) => {
                    setSorted(newSorted)
                    setCurrent(0)
                  }}
                />
                {
                  loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
                }
              </Div>
            )
          }
        }
      </Query>
    </Wrapper>
  )
}

export default Index
